/**
 * Diminova — 1–2 rayos neón simples sobre el PCB del logo.
 * Colores: cyan, verde, rojo neón. Timing impredecible.
 */
(function () {
  'use strict';

  if (window.__diminovaTeslaBound) return;
  window.__diminovaTeslaBound = true;

  const NEON = [
    { core: '#ffffff', mid: '#00d4ff', glow: '#0090ff' }, // azul / cyan
    { core: '#ffffff', mid: '#39ff14', glow: '#00c853' }, // verde neón
    { core: '#ffffff', mid: '#ff2d55', glow: '#ff0040' }, // rojo neón
  ];

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function nextDelay() {
    // ~3s o ~10s, con jitter
    if (Math.random() < 0.4) return rand(2800, 4200);
    return rand(9000, 14000);
  }

  function buildBolt(x0, y0, x1, y1, jag) {
    const pts = [{ x: x0, y: y0 }];
    const segs = 7 + Math.floor(Math.random() * 3);
    for (let i = 1; i < segs; i++) {
      const t = i / segs;
      pts.push({
        x: x0 + (x1 - x0) * t + (Math.random() - 0.5) * jag,
        y: y0 + (y1 - y0) * t + (Math.random() - 0.5) * jag * 0.45,
      });
    }
    pts.push({ x: x1, y: y1 });
    return pts;
  }

  function strokeBolt(ctx, pts, color, width, alpha, blur) {
    if (!pts.length) return;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.shadowColor = color;
    ctx.shadowBlur = blur;
    ctx.beginPath();
    ctx.moveTo(pts[0].x, pts[0].y);
    for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
    ctx.stroke();
    ctx.restore();
  }

  function sizeCanvas(el, canvas) {
    const img = el.querySelector('img');
    const base = img || el;
    const rect = base.getBoundingClientRect();
    if (rect.width < 4 || rect.height < 4) return false;

    const dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    const cssW = Math.max(24, Math.round(rect.width * 0.46));
    const cssH = Math.max(24, Math.round(rect.height * 1.22));

    canvas.style.width = cssW + 'px';
    canvas.style.height = cssH + 'px';
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    canvas.dataset.cssW = String(cssW);
    canvas.dataset.cssH = String(cssH);

    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cssW, cssH);
    return true;
  }

  function ensureCanvas(el) {
    let canvas = el.querySelector('canvas.diminova-logo-pcb__canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'diminova-logo-pcb__canvas';
      canvas.setAttribute('aria-hidden', 'true');
      el.appendChild(canvas);
    }
    sizeCanvas(el, canvas);
    return canvas;
  }

  function makeSimpleBolts(w, h) {
    const bolts = [];
    const count = Math.random() < 0.55 ? 1 : 2;
    const usedColors = [];

    for (let i = 0; i < count; i++) {
      // color distinto si hay dos rayos
      let palette = pick(NEON);
      let guard = 0;
      while (usedColors.includes(palette.mid) && guard < 6) {
        palette = pick(NEON);
        guard++;
      }
      usedColors.push(palette.mid);

      // trayectorias distintas: vertical, diagonal o en zigzag
      const style = Math.floor(Math.random() * 3);
      let x0;
      let y0;
      let x1;
      let y1;
      let jag;

      if (style === 0) {
        // vertical por una pista
        x0 = w * (0.28 + Math.random() * 0.44);
        y0 = rand(2, h * 0.12);
        x1 = x0 + rand(-10, 10);
        y1 = rand(h * 0.88, h - 2);
        jag = rand(7, 12);
      } else if (style === 1) {
        // diagonal
        x0 = w * (0.2 + Math.random() * 0.25);
        y0 = rand(2, h * 0.2);
        x1 = w * (0.55 + Math.random() * 0.3);
        y1 = rand(h * 0.8, h - 2);
        jag = rand(8, 14);
      } else {
        // otra diagonal opuesta / rama corta
        x0 = w * (0.55 + Math.random() * 0.25);
        y0 = rand(2, h * 0.18);
        x1 = w * (0.2 + Math.random() * 0.3);
        y1 = rand(h * 0.82, h - 2);
        jag = rand(8, 13);
      }

      bolts.push({ pts: buildBolt(x0, y0, x1, y1, jag), palette });
    }

    return bolts;
  }

  function strike(el, canvas) {
    if (!sizeCanvas(el, canvas)) return;

    const w = Number(canvas.dataset.cssW) || 1;
    const h = Number(canvas.dataset.cssH) || 1;
    const ctx = canvas.getContext('2d');
    const bolts = makeSimpleBolts(w, h);

    el.classList.add('is-striking');
    const start = performance.now();
    const duration = 700;

    function frame(now) {
      const t = (now - start) / duration;
      ctx.clearRect(0, 0, w, h);

      if (t >= 1) {
        ctx.clearRect(0, 0, w, h);
        el.classList.remove('is-striking');
        return;
      }

      let flash = 1;
      if (t < 0.1) flash = t / 0.1;
      else if (t > 0.3 && t < 0.36) flash = 0.2;
      else if (t > 0.36 && t < 0.45) flash = 1;
      else if (t > 0.72) flash = Math.max(0, 1 - (t - 0.72) / 0.28);

      bolts.forEach(({ pts, palette }) => {
        strokeBolt(ctx, pts, palette.glow, 6.5, flash * 0.4, 16);
        strokeBolt(ctx, pts, palette.mid, 3.2, flash * 0.95, 9);
        strokeBolt(ctx, pts, palette.core, 1.6, flash, 2);
      });

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function loop(el, canvas) {
    window.setTimeout(() => {
      if (!document.hidden) strike(el, canvas);
      loop(el, canvas);
    }, nextDelay());
  }

  function arm(el) {
    if (el.dataset.teslaArmed === 'true') return;
    el.dataset.teslaArmed = 'true';
    el.querySelector('svg.diminova-logo-pcb__bolts')?.remove();

    const img = el.querySelector('img');
    const start = () => {
      const canvas = ensureCanvas(el);
      window.setTimeout(() => {
        strike(el, canvas);
        loop(el, canvas);
      }, rand(1000, 2000));
    };

    if (img && !img.complete) {
      img.addEventListener('load', start, { once: true });
      window.setTimeout(start, 1200);
    } else {
      start();
    }
  }

  function boot() {
    document.querySelectorAll('[data-diminova-tesla]').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-diminova-tesla]').forEach((el) => {
      el.dataset.teslaArmed = 'false';
    });
    boot();
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-diminova-tesla]').forEach((el) => {
      const canvas = el.querySelector('canvas.diminova-logo-pcb__canvas');
      if (canvas) sizeCanvas(el, canvas);
    });
  });
})();
